const timesheetServiceServiceName = "/TimesheetManagement";

export function timesheetManagementService(http) {
    return {        
        getPersonnelDailyWork: (personnelCode, fromDate, toDate, year) => {
            return http.post(timesheetServiceServiceName + "/GetPersonnelDailyWork", {
                PersonnelCode: personnelCode,
                FromDate: fromDate,
                ToDate: toDate,
                Year: year
            });
        }

    }
}













